import Api from '@/services/Api';

export default {
	async getAdmins() {
		return await Api.get('/api/admins?order_by=first_name&order=asc&page=1');
	},
	async getAdmin(id) {
		return await Api.get(`/api/admin/${id}`);
	},
	async updateAdmin(admin) {
		if (admin.id) {
			return await Api.patch(`/api/admin/${admin.id}`, admin);
		}

		return await Api.post('/api/admin', admin);
	},
	async deleteAdmin(id) {
		return await Api.delete('/api/admin', { data: { admin_id: id } });
	},
	async getDeletedAdmins() {
		return await Api.get('/api/admins/deleted');
	},
	async restoreAdmin(id) {
		return await Api.patch('/api/admin/restore', { admin_id: id });
	},
	async destroyAdmin(id) {
		return await Api.delete('/api/admin/destroy', { data: { admin_id: id } });
	},
	async getSortedActiveAdmins(obj) {
		return await Api.get(`/api/admins?order_by=${obj.order_by}&order=${obj.order}&page=${obj.page}`);
	},
	async getSortedDeletedAdmins(obj) {
		return await Api.get(`/api/admins/deleted?order_by=${obj.order_by}&order=${obj.order}&page=${obj.page}`);
	}
};
